module.exports = __webpack_public_path__ + "static/media/arrow-circle-right_v2.9498a600.svg";